import { combineReducers } from 'redux';
import { orderDetailsReducer } from './order_details';
import { systemReducer } from './system';
import { App, BookingDetails, Cart, OrderDetails, PaymentConfig, RtrError, Search, Shipping, StepItem, StepOffers, Success, System, Term, Widget } from './types';
import { cartReducer } from './cart';
import { searchReducer } from './search';
import { stepsReducer } from './steps';
import { shippingReducer } from './shipping';
import { appReducer } from './app';
import { stepOffersReducer } from './step_offers';
import { termsReducer } from './terms';
import { paymentReducer } from './payment';
import { widgetReducer } from './widget';
import { successReducer } from './success';
import { bookingDetailsReducer } from './booking_details';
import { errorsReducer } from './errors';

// This interface represents app state by nesting feature states.
export interface RootState {
  app: App;
  bookingDetails: BookingDetails;
  orderDetails: OrderDetails;
  system: System;
  cart: Cart;
  steps: StepItem[];
  shipping: Shipping;
  stepOffers: StepOffers;
  terms: Term[];
  payment: PaymentConfig;
  widget: Widget;
  success: Success;
  search: Search;
  errors: RtrError[];
}

// Combine feature reducers into a single root reducer
export const rootReducer = combineReducers({
  app: appReducer,
  bookingDetails: bookingDetailsReducer,
  orderDetails: orderDetailsReducer,
  system: systemReducer,
  cart: cartReducer,
  steps: stepsReducer,
  shipping: shippingReducer,
  stepOffers: stepOffersReducer,
  terms: termsReducer,
  payment: paymentReducer,
  widget: widgetReducer,
  success: successReducer,
  search: searchReducer,
  errors: errorsReducer,
});

export const getSteps = (state: RootState): StepItem[] => {
  return state.steps;
};
